import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
import mediaApi from '@/api/media';
import { global_set } from '@/utils';
import { config } from '@/store';
import { useRoute, useRouter } from 'vue-router';
import { mediaType } from '@/type/media';

const __default__ = { name: 'media-list' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();
const router = useRouter();

const mediaList = ref<mediaType[]>([]);

/**
 * @description: 读取媒体库
 * @return {*}
 */
async function load_media() {
	const res = await mediaApi.get(1, 10000);
	mediaList.value = res.list;
}

/**
 * @description: 跳转漫画列表
 * @param {*} mediaId
 * @return {*}
 */
function go_manga_list(mediaInfo: mediaType) {
	const mediaId = mediaInfo.mediaId;

	if (mediaInfo.directoryFormat == 1) {
		router.push({
			name: 'parent-path-list',
			query: {
				mediaId,
			},
			params: { clear: '1' },
		});
		return;
	}

	// 设置媒体库id
	global_set('mediaId', mediaId);

	router.push({
		name: 'manga-list',
		query: {
			mediaId,
		},
		params: { clear: '1' },
	});
}

/**
 * @description: 上下文菜单
 * @return {*}
 */
function context_menu() {
	config.rightSidebar = true;
}

// 生命周期
onMounted(async () => {
	load_media();
})


const __returned__ = { route, router, mediaList, load_media, go_manga_list, context_menu }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})